import { render, staticRenderFns } from "./sellDealer.vue?vue&type=template&id=ba0bbfe4"
import script from "./sellDealer.vue?vue&type=script&lang=js"
export * from "./sellDealer.vue?vue&type=script&lang=js"
import style0 from "./sellDealer.vue?vue&type=style&index=0&id=ba0bbfe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealerTisk: require('/root/workspace/web-company_Yo6Q/components/dealer/head/dealerTisk.vue').default,DealerModule: require('/root/workspace/web-company_Yo6Q/components/dealer/head/dealerModule.vue').default})
